import { environment } from "src/environments/environment";
import { ContactPerson } from "./ContactPerson.interface";

export const INITIAL_CONTACT_PERSON: ContactPerson = (environment.mock && environment.mockContactPerson) ? {
    title: "Herr",
    firstName: "Han",
    lastName: "Solo",
    birthDate: new Date("1977-05-25"),
    phoneNumber: "06831 1234"
} : {
    title: "",
    firstName: "",
    lastName: "",
    birthDate: null,
    phoneNumber: "" 
}
